import { render, staticRenderFns } from "./JobRequirement.vue?vue&type=template&id=23b3684b&scoped=true&"
import script from "./JobRequirement.vue?vue&type=script&lang=js&"
export * from "./JobRequirement.vue?vue&type=script&lang=js&"
import style0 from "../../css/newCreateProject.css?vue&type=style&index=0&id=23b3684b&scoped=true&lang=css&"
import style1 from "./JobRequirement.vue?vue&type=style&index=1&id=23b3684b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3684b",
  null
  
)

export default component.exports